import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/warehouse-receiving/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/warehouse-receiving/incoming",
    })
  },
})
